import { Dispatch } from "@reduxjs/toolkit";
import { PackageState } from "../../utils/interfaces/packages";
import { setBundlePackages, setVirtualPackages } from "./reducer";

export const packageActionDispatch = (dispatch: Dispatch) => ({
  setBundlePackages: (packages: PackageState) =>
    dispatch(setBundlePackages(packages)),
  setVirtualPackages: (packages: PackageState) =>
    dispatch(setVirtualPackages(packages)),
});
